import React, { useState, useEffect } from 'react';

const VersionInfo = () => {
  const [buildTime, setBuildTime] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  const [uptime, setUptime] = useState('');

  useEffect(() => {
    // Get build time from package.json or use current time as fallback
    const getBuildTime = () => {
      try {
        // Try to get build time from package.json
        const packageInfo = require('../../../package.json');
        if (packageInfo.buildTime) {
          return new Date(packageInfo.buildTime);
        }
      } catch (error) {
        console.log('Could not read package.json build time');
      }
      
      // Fallback to current time
      return new Date();
    };
    
    const buildTimeDate = getBuildTime();
    setBuildTime(buildTimeDate.toLocaleString());
    
    // Calculate uptime based on build time, not page load time
    const updateUptime = () => {
      const now = new Date();
      const elapsed = now.getTime() - buildTimeDate.getTime();
      
      // Calculate days, hours, minutes, seconds
      const days = Math.floor(elapsed / (1000 * 60 * 60 * 24));
      const hours = Math.floor((elapsed % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((elapsed % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((elapsed % (1000 * 60)) / 1000);
      
      let uptimeString = '';
      if (days > 0) {
        uptimeString = `${days}d ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      } else {
        uptimeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }
      
      setUptime(uptimeString);
    };
    
    updateUptime();
    const interval = setInterval(updateUptime, 1000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div 
        className={`bg-gray-900 text-white rounded-lg shadow-2xl border border-gray-700 transition-all duration-300 ${
          isExpanded ? 'w-64' : 'w-32'
        }`}
      >
        {/* Header - always visible */}
        <div 
          className="px-3 py-2 cursor-pointer hover:bg-gray-800 transition-colors duration-200 rounded-t-lg"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
              <span className="text-blue-400 font-semibold text-xs">
                INFO
              </span>
            </div>
            <div className="text-gray-400 text-xs">
              {isExpanded ? '−' : '+'}
            </div>
          </div>
        </div>
        
        {/* Expanded content */}
        {isExpanded && (
          <div className="px-3 pb-3 border-t border-gray-700">
            <div className="space-y-2 pt-2">
              <div className="text-xs">
                <div className="text-gray-400">Build Time:</div>
                <div className="text-gray-200 font-mono">{buildTime}</div>
              </div>
              
              <div className="text-xs">
                <div className="text-gray-400">Build Age:</div>
                <div className="text-gray-200 font-mono">{uptime}</div>
              </div>
              
              <div className="text-xs">
                <div className="text-gray-400">Version:</div>
                <div className="text-gray-200 font-mono">
                  {require('../../../package.json').version || '0.1.0'}
                </div>
              </div>
              
              <div className="text-xs">
                <div className="text-gray-400">React:</div>
                <div className="text-gray-200 font-mono">{React.version}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VersionInfo;
